import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import receptionWebP from '@/assets/reception.webp';
import receptionJpg from '@/assets/reception.jpg';

const AboutSection: React.FC = () => {
  return (
    <section id="about" className="section-padding bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="mb-4 bg-gradient-to-r from-sage-600 to-amber-500 bg-clip-text text-transparent">About Women & The Way</h2>
          <p className="max-w-3xl mx-auto text-lg text-gray-700">
          At Women and the Way, we honour the unique path of every woman. Based in Currimundi on the Sunshine Coast, we offer gentle, personalised care grounded in Traditional Chinese Medicine.
          From the teenage years through fertility, pregnancy, and into menopause, we walk beside you  -  offering acupuncture, herbal medicine, and lifestyle guidance to support your body, mind, and spirit.          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <div className="rounded-2xl overflow-hidden shadow-lg border-4 border-amber-200/30 bg-sage-50 min-h-[12rem]">
              <picture>
                <source srcSet={receptionWebP} type="image/webp" />
                <img
                  src={receptionJpg}
                  alt="Women and the Way clinic reception — supporting women’s health on the Sunshine Coast"
                  className="w-full h-auto block"
                  sizes="(max-width: 768px) 100vw, 50vw"
                  loading="eager"
                  fetchPriority="high"
                  decoding="async"
                />
              </picture>
            </div>
          </div>
          <div>
            <h3 className="text-2xl font-serif font-medium mb-4 text-sage-800">Our Philosophy</h3>
            <p className="mb-4 text-gray-700">
            Women experience transformative changes every seven years  -  physically, emotionally, and energetically. At Women and the Way, we embrace this rhythm and provide care that aligns with these natural cycles.
            </p>
            <p className="mb-6 text-gray-700">
            We offer weekly treatments, empowering events, immersive retreats, and nourishing programs designed to reconnect you with your inner wisdom.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
              <Card className="rounded-2xl shadow-md bg-gradient-to-br from-white to-amber-50 p-6 border-2 border-amber-200/30 transition-all duration-300 hover:shadow-lg hover:-translate-y-1">
                <CardContent className="p-6">
                  <h4 className="font-serif text-lg font-medium mb-2 text-amber-700">Classical TCM Approach</h4>
                  <p className="text-gray-600">We treat the whole person using time-tested Chinese Medicine principles for true healing and balance.</p>
                </CardContent>
              </Card>
              <Card className="rounded-2xl shadow-md bg-gradient-to-br from-white to-amber-50 p-6 border-2 border-amber-200/30 transition-all duration-300 hover:shadow-lg hover:-translate-y-1">
                <CardContent className="p-6">
                  <h4 className="font-serif text-lg font-medium mb-2 text-amber-700">Personalised Care</h4>
                  <p className="text-gray-600">Every treatment plan is customised based on your unique pattern diagnosis according to TCM principles.</p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
